/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_OrInputs */

const en_portalsignin_or = /** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const ar_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const he_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const ur_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const es_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const fr_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const de_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const pt_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const hi_portalsignin_or = en_portalsignin_or;

/** @type {(inputs: Portalsignin_OrInputs) => LocalizedString} */
const bn_portalsignin_or = en_portalsignin_or;

/**
* | output |
* | --- |
* | "or" |
*
* @param {Portalsignin_OrInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_or = /** @type {((inputs?: Portalsignin_OrInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_OrInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_or(inputs)
	if (locale === "he") return he_portalsignin_or(inputs)
	if (locale === "ur") return ur_portalsignin_or(inputs)
	if (locale === "es") return es_portalsignin_or(inputs)
	if (locale === "fr") return fr_portalsignin_or(inputs)
	if (locale === "de") return de_portalsignin_or(inputs)
	if (locale === "pt") return pt_portalsignin_or(inputs)
	if (locale === "hi") return hi_portalsignin_or(inputs)
	if (locale === "bn") return bn_portalsignin_or(inputs)
	return /** @type {LocalizedString} */ ("or")
});